export const isMobile = () =>
  /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
  !/iPad|Tablet/i.test(navigator.userAgent);

export const isSmallScreen = () => window.innerWidth < 768;
